module.exports = __webpack_public_path__ + "static/media/logo-repco.e5cdf8bb.svg";